module.exports = __webpack_public_path__ + "static/media/djeeta-lose.d69e0456.png";